require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-jeff-malek.json") })
        }
      }, "path---blog-author-jeff-malek");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-jeff-malek!./.cache/json/blog-author-jeff-malek.json
// module id = 656
// module chunks = 231608221292675